var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"col-12 col-md-6 col-lg-4 d-flex flex-column"},[_c('my-latest-updates',{attrs:{"hide-if-empty":true,"endpoint":_vm.endpoint,"link":_vm.link,"link-text":_vm.linkText}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }